type ClassNameString = string | undefined;
type ClassNameObject = { [key: string]: boolean };
type ClassNameArray = ClassNames[];

export type ClassNames = ClassNameString | ClassNameObject | ClassNameArray;

export function mergeClasses(...names: ClassNames[]): string {
  return (
    names
      ?.map((name) => {
        if (Array.isArray(name)) {
          return mergeClasses(...name);
        }

        if (typeof name === "object") {
          return Object.keys(name)
            .filter((key) => name[key])
            .join(" ");
        }

        return name;
      })
      .filter(Boolean)
      .join(" ") ?? ""
  );
}
